import { z } from '@hono/zod-openapi'

// id
export const idZ = z.number().openapi({ description: '部屋ID', example: 1 })
export type id = z.infer<typeof idZ>

// propertyId
export const propertyIdZ = z
  .number()
  .openapi({ description: '部屋が属する物件ID', example: 101 })
export type propertyId = z.infer<typeof propertyIdZ>

// name: 部屋番号
export const nameZ = z
  .string()
  .openapi({ description: '部屋番号', example: '101' })
export type name = z.infer<typeof nameZ>

// status: 状態
// export const ROOM_STATUS_EMPTY = '1'
// export const ROOM_STATUSES = [
//   { key: ROOM_STATUS_EMPTY, value: '居住用' },
// ] as const
// export const statusZ = z
//   .enum([ROOM_STATUS_EMPTY])
//   .openapi({ example: ROOM_STATUS_EMPTY })
// export type status = z.infer<typeof statusZ>

// layout: 間取り
export const layoutZ = z
  .string()
  .openapi({ description: '間取り', example: '1LDK' })
export type layout = z.infer<typeof layoutZ>

// size: 面積
export const sizeZ = z
  .number()
  .openapi({ description: '専有面積（平方メートル）', example: 45.67 })
export type size = z.infer<typeof sizeZ>

// floor: 階数
export const floorZ = z
  .number()
  .openapi({ description: '部屋の所在階', example: 1 })
export type floor = z.infer<typeof floorZ>

// adminMemo: 管理者メモ
export const adminMemoZ = z
  .string()
  .openapi({ description: '管理者用メモ（社内用）', example: '要清掃' })
export type adminMemo = z.infer<typeof adminMemoZ>

// createdAt: 作成日時
export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt: 更新日時
export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>

// deletedAt: 削除日時
export const deletedAtStringZ = z
  .string()
  .nullable()
  .openapi({ description: '削除日時（ISO8601）。null は未削除', example: null })
export type deletedAtString = z.infer<typeof deletedAtStringZ>

export const deletedAtDateZ = z.date().nullable().openapi({ example: null })
export type deletedAtDate = z.infer<typeof deletedAtDateZ>

// ownerDeletedAt: オーナー削除日時
export const ownerDeletedAtStringZ = z
  .string()
  .nullable()
  .openapi({ example: null })
export type ownerDeletedAtString = z.infer<typeof ownerDeletedAtStringZ>

export const ownerDeletedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: null })
export type ownerDeletedAtDate = z.infer<typeof ownerDeletedAtDateZ>

// echoesResidenceId（Echoesの部屋ID）
export const echoesResidenceIdZ = z
  .string()
  .nullable()
  .openapi({ example: '10' })
export type echoesResidenceId = z.infer<typeof echoesResidenceIdZ>

// echoesUpdatedAt（取り込み済み Echoes レコードの updated_at。等値比較で洗替要否を判定する）
export const echoesUpdatedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: null })
export type echoesUpdatedAtDate = z.infer<typeof echoesUpdatedAtDateZ>

// echoesFailedAt（Echoesからの同期に最後に失敗した日時。成功時は null に戻す）
export const echoesFailedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: null })
export type echoesFailedAtDate = z.infer<typeof echoesFailedAtDateZ>
